import type { FormError } from 'models/formError';
import { createContext, useContext } from 'react';
export const ValidationErrorsContext = createContext<readonly FormError[]>([]);

export const useExistsValidationErrorFor = (field: string) => {
  const context = useContext(ValidationErrorsContext);
  return context.some(error => error.fields?.some(f => f === field));
};
